import { MessageValue } from 'locale';
import { IntlShape } from 'react-intl';
import { formatIntlMessage, IntlModuleTypes, useIntlModule } from '@enterprise/common';
import messages from './exports.intl.json';

export const useExportsIntl = () => useIntlModule(messages);

export type IntlExports = ReturnType<typeof useExportsIntl>;

export function formatExportsMessage(
  intl: IntlShape,
  message: IntlModuleTypes.IntlKeys<typeof messages>,
  variables?: Record<string, MessageValue>
) {
  return formatIntlMessage(intl, messages, message, variables);
}
